import React, { useState } from "react";
import "../static/Login.css";

function Register() {
  const [formData, setFormData] = useState({
    fullName: "", email: "", course: "", password: "", confirmPassword: ""
  });
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validate = () => {
    let errs = {};
    if (formData.fullName.length < 3) errs.fullName = "Enter full name";
    if (!formData.email.match(/^\S+@\S+\.\S+$/)) errs.email = "Invalid email";
    if (!formData.course) errs.course = "Select a course";
    if (formData.password.length < 6) errs.password = "Min 6 chars";
    if (formData.password !== formData.confirmPassword) errs.confirmPassword = "No match";
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSignup = (e) => {
    e.preventDefault();
    if (validate()) alert("Success 🎓");
  };

  return (
    <div className="login-wrapper">
      <div className="shooting-star"></div>
      <div className="login-card">
        <h2 className="login-title">Join Academy 🎓</h2>
        <p className="login-subtitle">Start your cosmic journey</p>
        <form onSubmit={handleSignup} noValidate>
          <div className={`input-group ${errors.fullName ? "error" : ""}`}>
            <input type="text" name="fullName" value={formData.fullName} onChange={handleChange} required />
            <label>Full Name</label>
            {errors.fullName && <span className="error-msg">{errors.fullName}</span>}
          </div>
          <div className={`input-group ${errors.email ? "error" : ""}`}>
            <input type="email" name="email" value={formData.email} onChange={handleChange} required />
            <label>Email Address</label>
            {errors.email && <span className="error-msg">{errors.email}</span>}
          </div>
          <div className={`input-group ${errors.course ? "error" : ""}`}>
             <select name="course" value={formData.course} onChange={handleChange} required className="course-select">
                <option value="" disabled hidden></option>
                <option value="web-dev">Web Development</option>
                <option value="data-science">Data Science</option>
                <option value="cyber">Cyber Security</option>
             </select>
             <label>Select Course</label>
             {errors.course && <span className="error-msg">{errors.course}</span>}
          </div>
          <div className={`input-group ${errors.password ? "error" : ""}`}>
            <input name="password" type={showPassword ? "text" : "password"} value={formData.password} onChange={handleChange} required />
            <label>Password</label>
            <button type="button" className="show-pass-btn" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? "HIDE" : "SHOW"}
            </button>
            {errors.password && <span className="error-msg">{errors.password}</span>}
          </div>
          <div className={`input-group ${errors.confirmPassword ? "error" : ""}`}>
            <input type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} required />
            <label>Confirm Password</label>
            {errors.confirmPassword && <span className="error-msg">{errors.confirmPassword}</span>}
          </div>
          <button type="submit" className="login-btn">Create Account 🚀</button>
        </form>
        <p className="signup-link">Already a student? <a href="/login"><span>Login Here</span></a></p>
      </div>
    </div>
  );
}
export default Register;
